import { useConfigurationValue } from "@/hooks/useSystemConfiguration";
import { Configurations } from "@/constants";
import { useMemo } from "react";

export const useDocumentMimeTypes = () => {
  const documentMimeTypes = useConfigurationValue<string>(
    Configurations.DOCUMENT_MIME_TYPES
  );
  const documentPrimaryMimeTypes = useConfigurationValue<string>(
    Configurations.DOCUMENT_PRIMARY_MIME_TYPES
  );

  const allMimeTypes = useMemo(() => {
    return documentMimeTypes || "";
  }, [documentMimeTypes]);

  const primaryMimeTypes = useMemo(() => {
    return documentPrimaryMimeTypes || "";
  }, [documentPrimaryMimeTypes]);

  const fallbackMimeTypes = useMemo(() => {
    return ".doc, .xls, .ppt, .txt, .docx, .xlsx, .pptx, .pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf";
  }, []);

  return {
    allMimeTypes: allMimeTypes || fallbackMimeTypes,
    primaryMimeTypes: primaryMimeTypes || fallbackMimeTypes,
    documentMimeTypes,
    documentPrimaryMimeTypes,
    isLoaded: !!documentMimeTypes,
  };
};
